/* eslint-disable import/no-cycle */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import isEqual from 'lodash/isEqual';
import { useStoreState } from '../../../../../models/hooks';
import { useGetItemProperty } from '../../hooks/useGetItemProperty';
import TextInput from '../../formInputs/TextInput';
import { useUpdateFormItem } from '../../hooks/useUpdateFormItem';
import withToggleVisibility from '../../utils/withToggleVisibility';
import { ValidationTypeEnum } from '../../hooks/useHireFormErrorHandling';
import { TextPreviewElement } from '../../formInputs/FormTextInput';
import { FieldDocumentReviewT, TextWithTranslationsT } from '../../types';

interface DocumentTextInputProps {
  fieldId: string;
  placeholder?: string;
  onBlur?: () => void;
  isAdvanced?: boolean;
}
function InputComponent({ fieldId, onBlur, isAdvanced }: DocumentTextInputProps) {
  const language = useStoreState((state) => state.formBuilder.currentLanguage);
  const defaultLanguage = useStoreState((state) => state.formBuilder.defaultLanguage);
  const languages = useStoreState((state) => state.formBuilder.availableLanguages);
  const handleOnChange = useUpdateFormItem();
  const value = useGetItemProperty<FieldDocumentReviewT['acknowledgeContent'] | null | undefined>(
    fieldId,
    'documentReview.acknowledgeContent',
  );

  const handleDescriptionChange = React.useCallback(
    (newDescription: string) => {
      const updatedValue = { ...value, [language]: newDescription };
      handleOnChange(fieldId, { documentReview: { acknowledgeContent: updatedValue } });
      onBlur?.();
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [value, language, defaultLanguage, languages, handleOnChange],
  );
  return (
    <TextInput
      fieldId={fieldId}
      property="documentReview"
      innerPath={`acknowledgeContent.${language}`}
      language={language}
      label={value?.[language] || ''}
      onLabelChange={handleDescriptionChange}
      placeholder="Enter description here...."
      isAdvanced={isAdvanced || false}
    />
  );
}

const InputComponentWrapper = withToggleVisibility(InputComponent);
const DocumentAcknowledgeTextInput = React.memo(
  ({ fieldId, isAdvanced }: { fieldId: string; isAdvanced: boolean }) => {
    const language = useStoreState((state) => state.formBuilder.currentLanguage);
    const currentValue =
      useGetItemProperty<TextWithTranslationsT | null | undefined>(fieldId, `documentReview.acknowledgeContent`) || {};

    return (
      <InputComponentWrapper
        innerPath={`acknowledgeContent.${language}`}
        initialValue={currentValue}
        validate={(callback, value) => {
          callback(value);
        }}
        validationType={ValidationTypeEnum.TEXT}
        currentLanguage={language}
        fieldId={fieldId}
        // path={fullPathToData}
        isAdvanced={isAdvanced}
        placeholder="Enter acknowledgement text here...."
        previewComponent={(value, error, placeholder) => (
          <TextPreviewElement value={value} error={error} placeholderText={placeholder} sx={{ flex: 1 }} />
        )}
      />
    );
  },
  (p, n) => isEqual(p.fieldId, n.fieldId),
);

export default DocumentAcknowledgeTextInput;
